import React from 'react';
import logoFull from '../images/logo-full.png';
import './Home.scss';
import { useAuth } from 'react-oidc-context';
import loadingImage from '../images/loading-radar.svg';
import { t } from 'i18next';

const Home = (): React.JSX.Element => {
  const auth = useAuth();

  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>;
  }

  const renderLoginButton = (): React.JSX.Element => {
    if (auth.isLoading) {

      return (
        <div className="d-flex flex-column align-items-center">
          <img src={loadingImage} alt="Redirecionando..." height={50} width={50} />
          {t("authentication.redirecting")}
        </div>
      )
    }

    return <button className="btn btn-clear btn-lg px-5 py-3" onClick={() => auth.signinRedirect()}>{t("authentication.signIn")}</button>
  }

  return (
    <div className="container-fluid p-0" id="login">
      <div className="row p-0 m-0">
        <div className="col-6 login-image p-0"></div>
        <div className="col-6 login-text p-0 d-flex justify-content-center align-items-center flex-column">
          <img src={logoFull} className="logo-full d-block mb-5" alt="Feedback Canvas Logo" />
          {renderLoginButton()}
        </div>
      </div>
    </div>
  );
}

export default Home;
